import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

const content = {
  de: {
    title: 'Datenschutzerklärung',
    back: 'Zurück',
    intro: 'Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Diese Datenschutzerklärung informiert Sie nach Art. 13 DSGVO darüber, welche personenbezogenen Daten wir erheben, zu welchem Zweck wir sie verwenden, an welche Empfänger wir sie übermitteln und welche Rechte Sie haben.',
    sections: [
      {
        heading: '1. Verantwortliche Stelle',
        text: `Verantwortlicher im Sinne der DSGVO ist:

EnBet Consulting UG (haftungsbeschränkt)
Im Tal 30
34270 Schauenburg
Deutschland

E-Mail: info@enbet-consulting.de
Telefon: +49 176 23943896
USt-ID: DE346037206

Geschäftsführer: Sebastian Funke`
      },
      {
        heading: '2. Hosting und Server-Logfiles',
        text: `Frontend-Hosting (Website-Auslieferung): STRATO AG, Otto-Ostrowski-Straße 7, 10249 Berlin, Deutschland. Server in Deutschland. Mit STRATO besteht ein Auftragsverarbeitungsvertrag.

Backend-Hosting (Anwendungs-Server): Hetzner Online GmbH, Industriestraße 25, 91710 Gunzenhausen, Deutschland. Server in Nürnberg, Deutschland. Mit Hetzner besteht ein Auftragsverarbeitungsvertrag.

Beim Besuch der Website werden technisch notwendige Daten in Server-Logfiles erfasst (IP-Adresse, Datum/Uhrzeit, Browser-Typ, Referrer, aufgerufene Seite). Diese Daten werden ausschließlich zur technischen Bereitstellung der Website und zur Abwehr von Angriffen verarbeitet. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer funktionsfähigen und sicheren Website). Speicherdauer: max. 30 Tage.`
      },
      {
        heading: '3. Datenbank — Supabase',
        text: `Wir speichern Lead- und Kommunikationsdaten in einer von Supabase Inc. (USA) betriebenen PostgreSQL-Datenbank. Unsere Daten liegen ausschließlich auf Servern in der EU (Region Frankfurt, Deutschland). Mit Supabase besteht ein Auftragsverarbeitungsvertrag inklusive EU-Standardvertragsklauseln.

Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) und lit. f DSGVO (berechtigtes Interesse an Lead-Management).`
      },
      {
        heading: '4. Chatbot ("Tom") — KI-gestützte Beratungsanfrage',
        text: `Unser Chatbot Tom nutzt Künstliche Intelligenz, um Erstgespräche zu führen und Termine zu vereinbaren. Die Nutzung erfolgt nur nach Ihrer Zustimmung zur Datenverarbeitung (Einblendung vor dem Chat).

Verarbeitete Daten: Name, E-Mail, Unternehmen, Branche, Gesprächsinhalte, Terminwünsche.

Eingesetzter KI-Dienst: Anthropic PBC, 548 Market St, PMB 90375, San Francisco, CA 94104, USA (Modell „Claude"). Mit Anthropic besteht ein Auftragsverarbeitungsvertrag inklusive EU-Standardvertragsklauseln. Anthropic speichert API-Inhalte nicht für Trainingszwecke.

Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) und lit. b DSGVO (Vertragsanbahnung).

Drittlandtransfer USA: Anthropic ist nach dem EU-US Data Privacy Framework zertifiziert. Übermittlung erfolgt auf Grundlage des Angemessenheitsbeschlusses der EU-Kommission vom 10.07.2023.`
      },
      {
        heading: '5. Terminbuchung — Google Calendar & Google Meet',
        text: `Unser Buchungs-Widget übermittelt Ihre Termindaten direkt an Google Calendar. Die Bestätigungs-E-Mail mit Google Meet-Link wird über die Gmail-API versendet.

Verarbeitete Daten: Name, E-Mail, Unternehmen (optional), Termin-Datum und -Uhrzeit, ggf. Notizen.

Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland (Mutterkonzern: Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA).

Mit Google besteht ein Auftragsverarbeitungsvertrag. Datenübermittlung in die USA erfolgt auf Grundlage des EU-US Data Privacy Framework (zertifiziert). Google-Datenschutzerklärung: https://policies.google.com/privacy

Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung).`
      },
      {
        heading: '6. Lead-Management (internes CRM)',
        text: `Anfragen über Chatbot, Buchungs-Widget oder Kontaktformular werden in unserem internen CRM-System gespeichert. Wir verarbeiten Ihre Kontaktdaten und Gesprächsverlauf um:
- Ihre Anfrage zu bearbeiten
- Ihnen relevante Informationen zukommen zu lassen
- Termine zu koordinieren
- Bei Bedarf Follow-up-E-Mails zu versenden (mit Ihrer Zustimmung oder bei laufender Kundenbeziehung)

Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung/Vertragserfüllung) und lit. f DSGVO (berechtigtes Interesse an Geschäftspflege).

Speicherdauer: bis zum Widerruf bzw. längstens 3 Jahre nach letzter Interaktion.`
      },
      {
        heading: '7. E-Mail-Versand',
        text: `Transaktionale E-Mails (z.B. Terminbestätigungen) werden über die Gmail-API von Google (siehe Punkt 5) versendet.

Für bestimmte Massen-E-Mails (z.B. Einladungen, Reminder) nutzen wir zusätzlich: Resend, Inc., 2261 Market Street #5039, San Francisco, CA 94114, USA. Mit Resend besteht ein Auftragsverarbeitungsvertrag inklusive EU-Standardvertragsklauseln.

Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung/Vertragserfüllung) oder lit. a DSGVO (Einwilligung bei Marketing).`
      },
      {
        heading: '8. Analytics — PostHog',
        text: `Wir nutzen PostHog Inc., 2261 Market Street #4008, San Francisco, CA 94114, USA, zur Analyse der Website-Nutzung. Erfasst werden anonymisierte Nutzungsdaten (Seitenaufrufe, Klicks, Geräte-Informationen).

PostHog wird nur bei erteilter Einwilligung über das Cookie-Banner aktiviert. IP-Adressen werden vor der Speicherung gekürzt.

Mit PostHog besteht ein Auftragsverarbeitungsvertrag inklusive EU-Standardvertragsklauseln.

Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).`
      },
      {
        heading: '9. Cookies und Cookie-Consent',
        text: `Wir verwenden technisch notwendige Cookies (für Session-Management, Login etc.) sowie — nach Ihrer Zustimmung — Cookies für Analyse-Zwecke.

Beim ersten Besuch wird ein Cookie-Banner angezeigt. Sie können Ihre Einwilligung jederzeit über die Einstellungen widerrufen.

Rechtsgrundlage: § 25 Abs. 2 TTDSG (technisch notwendig) bzw. § 25 Abs. 1 TTDSG i.V.m. Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).`
      },
      {
        heading: '10. Google Fonts',
        text: `Diese Website bindet Schriftarten von Google Fonts (Anbieter: Google Ireland Limited, siehe Punkt 5) ein. Beim Aufruf einer Seite werden Schriftarten direkt vom Google-Server geladen, wobei Ihre IP-Adresse an Google übermittelt wird.

Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einheitlichem Schriftbild).

Hinweis: Eine lokale Einbindung der Schriftarten ist in Planung um die Datenübermittlung zu vermeiden.`
      },
      {
        heading: '11. Ihre Rechte als betroffene Person',
        text: `Sie haben das Recht auf:
- Auskunft über die zu Ihrer Person gespeicherten Daten (Art. 15 DSGVO)
- Berichtigung unrichtiger Daten (Art. 16 DSGVO)
- Löschung Ihrer Daten (Art. 17 DSGVO, "Recht auf Vergessenwerden")
- Einschränkung der Verarbeitung (Art. 18 DSGVO)
- Datenübertragbarkeit (Art. 20 DSGVO)
- Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)
- Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO) mit Wirkung für die Zukunft
- Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)

Zur Ausübung Ihrer Rechte wenden Sie sich an: info@enbet-consulting.de

Zuständige Aufsichtsbehörde: Der Hessische Beauftragte für Datenschutz und Informationsfreiheit, Postfach 3163, 65021 Wiesbaden.`
      },
      {
        heading: '12. Datensicherheit',
        text: `Wir nutzen Transport Layer Security (TLS/SSL) zur verschlüsselten Übertragung aller Daten zwischen Ihrem Browser und unseren Servern. Passwörter werden ausschließlich als bcrypt-Hash gespeichert. Zugriffe auf unsere Datenbank erfolgen nur über authentifizierte Service-Keys.`
      },
      {
        heading: '13. Stand und Änderungen dieser Datenschutzerklärung',
        text: `Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Mai 2026. Wir behalten uns vor, die Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen.`
      },
    ],
  },
  en: {
    title: 'Privacy Policy',
    back: 'Back',
    intro: 'We take the protection of your personal data very seriously. This privacy policy informs you in accordance with Art. 13 GDPR about which personal data we collect, for what purposes we use it, to which recipients we transmit it and what rights you have.',
    sections: [
      {
        heading: '1. Data Controller',
        text: `The data controller within the meaning of the GDPR is:

EnBet Consulting UG (haftungsbeschränkt)
Im Tal 30
34270 Schauenburg
Germany

Email: info@enbet-consulting.de
Phone: +49 176 23943896
VAT ID: DE346037206

Managing Director: Sebastian Funke`
      },
      {
        heading: '2. Hosting and Server Log Files',
        text: `Frontend hosting (website delivery): STRATO AG, Otto-Ostrowski-Straße 7, 10249 Berlin, Germany. Servers located in Germany. A data processing agreement (DPA) is in place with STRATO.

Backend hosting (application server): Hetzner Online GmbH, Industriestraße 25, 91710 Gunzenhausen, Germany. Servers located in Nuremberg, Germany. A DPA is in place with Hetzner.

When you visit our website, technically necessary data is logged in server log files (IP address, date/time, browser type, referrer, page requested). This data is used exclusively for technical website delivery and to prevent attacks. Legal basis: Art. 6(1)(f) GDPR (legitimate interest in a functional and secure website). Retention: max. 30 days.`
      },
      {
        heading: '3. Database — Supabase',
        text: `We store lead and communication data in a PostgreSQL database operated by Supabase Inc. (USA). Our data is stored exclusively on servers in the EU (Frankfurt, Germany region). A DPA including EU Standard Contractual Clauses is in place with Supabase.

Legal basis: Art. 6(1)(b) GDPR (pre-contractual measures) and (f) GDPR (legitimate interest in lead management).`
      },
      {
        heading: '4. Chatbot ("Tom") — AI-Powered Inquiry',
        text: `Our chatbot Tom uses artificial intelligence to conduct initial conversations and schedule appointments. Use requires your consent to data processing (shown before the chat starts).

Data processed: name, email, company, industry, conversation content, appointment preferences.

AI provider used: Anthropic PBC, 548 Market St, PMB 90375, San Francisco, CA 94104, USA ("Claude" model). A DPA including EU Standard Contractual Clauses is in place with Anthropic. Anthropic does not store API content for training purposes.

Legal basis: Art. 6(1)(a) GDPR (consent) and (b) GDPR (pre-contractual measures).

USA third-country transfer: Anthropic is certified under the EU-US Data Privacy Framework. Transfer takes place on the basis of the European Commission's adequacy decision of 10/07/2023.`
      },
      {
        heading: '5. Appointment Booking — Google Calendar & Google Meet',
        text: `Our booking widget transfers your appointment data directly to Google Calendar. The confirmation email with Google Meet link is sent via the Gmail API.

Data processed: name, email, company (optional), appointment date and time, optional notes.

Provider: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland (parent company: Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA).

A DPA is in place with Google. Data transfer to the USA takes place on the basis of the EU-US Data Privacy Framework (certified). Google's Privacy Policy: https://policies.google.com/privacy

Legal basis: Art. 6(1)(b) GDPR (pre-contractual measures).`
      },
      {
        heading: '6. Lead Management (Internal CRM)',
        text: `Inquiries via chatbot, booking widget or contact form are stored in our internal CRM system. We process your contact details and conversation history to:
- Process your inquiry
- Provide you with relevant information
- Coordinate appointments
- Send follow-up emails (with your consent or in the context of an ongoing customer relationship)

Legal basis: Art. 6(1)(b) GDPR (pre-contractual measures/contract performance) and (f) GDPR (legitimate interest in business relations).

Retention: until revocation, but no longer than 3 years after last interaction.`
      },
      {
        heading: '7. Email Delivery',
        text: `Transactional emails (e.g. booking confirmations) are sent via the Google Gmail API (see Section 5).

For certain bulk emails (e.g. invitations, reminders) we additionally use: Resend, Inc., 2261 Market Street #5039, San Francisco, CA 94114, USA. A DPA including EU Standard Contractual Clauses is in place with Resend.

Legal basis: Art. 6(1)(b) GDPR (pre-contractual/contract performance) or (a) GDPR (consent for marketing).`
      },
      {
        heading: '8. Analytics — PostHog',
        text: `We use PostHog Inc., 2261 Market Street #4008, San Francisco, CA 94114, USA, to analyze website usage. Anonymized usage data (page views, clicks, device information) is recorded.

PostHog is only activated upon consent given via the cookie banner. IP addresses are shortened before storage.

A DPA including EU Standard Contractual Clauses is in place with PostHog.

Legal basis: Art. 6(1)(a) GDPR (consent).`
      },
      {
        heading: '9. Cookies and Cookie Consent',
        text: `We use technically necessary cookies (for session management, login etc.) as well as — with your consent — cookies for analysis purposes.

On your first visit, a cookie banner is displayed. You can revoke your consent at any time via the settings.

Legal basis: Section 25(2) TTDSG (technically necessary) or Section 25(1) TTDSG in conjunction with Art. 6(1)(a) GDPR (consent).`
      },
      {
        heading: '10. Google Fonts',
        text: `This website embeds fonts from Google Fonts (provider: Google Ireland Limited, see Section 5). When a page is loaded, fonts are loaded directly from the Google server, whereby your IP address is transmitted to Google.

Legal basis: Art. 6(1)(f) GDPR (legitimate interest in consistent typography).

Note: Local embedding of fonts is planned to avoid data transmission.`
      },
      {
        heading: '11. Your Rights as a Data Subject',
        text: `You have the right to:
- Information about the data stored about you (Art. 15 GDPR)
- Correction of inaccurate data (Art. 16 GDPR)
- Deletion of your data (Art. 17 GDPR, "right to be forgotten")
- Restriction of processing (Art. 18 GDPR)
- Data portability (Art. 20 GDPR)
- Object to processing (Art. 21 GDPR)
- Withdraw consent (Art. 7(3) GDPR) with effect for the future
- Lodge a complaint with a supervisory authority (Art. 77 GDPR)

To exercise your rights, contact: info@enbet-consulting.de

Competent supervisory authority: The Hessian Commissioner for Data Protection and Freedom of Information, P.O. Box 3163, 65021 Wiesbaden.`
      },
      {
        heading: '12. Data Security',
        text: `We use Transport Layer Security (TLS/SSL) for encrypted transmission of all data between your browser and our servers. Passwords are stored exclusively as bcrypt hashes. Database access is only via authenticated service keys.`
      },
      {
        heading: '13. Status and Changes to This Privacy Policy',
        text: `This privacy policy is currently valid as of May 2026. We reserve the right to update this privacy policy in line with current legal requirements or to implement changes to our services.`
      },
    ],
  },
};

export default function DatenschutzPage({ onClose }) {
  const { lang } = useLanguage();
  const c = content[lang];

  return (
    <motion.div
      data-testid="datenschutz-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] bg-white overflow-y-auto"
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <button
          data-testid="datenschutz-back-btn"
          onClick={onClose}
          className="flex items-center gap-2 text-[#1f1f1f]/60 hover:text-[#1f1f1f] mb-10 transition-colors"
          style={{ fontFamily: "'Manrope', sans-serif" }}
        >
          <ArrowLeft size={16} /> {c.back}
        </button>
        <h1 className="text-[#1f1f1f] text-3xl md:text-4xl font-bold uppercase tracking-tight leading-[1.3] mb-6" style={{ fontFamily: "'Oswald', sans-serif" }}>
          {c.title}
        </h1>
        <p className="text-[#1f1f1f]/70 text-base leading-relaxed mb-12" style={{ fontFamily: "'Manrope', sans-serif" }}>
          {c.intro}
        </p>
        <div className="space-y-8">
          {c.sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-[#1f1f1f] text-xl font-bold uppercase tracking-tight mb-3" style={{ fontFamily: "'Oswald', sans-serif" }}>
                {s.heading}
              </h2>
              <p className="text-[#1f1f1f]/70 text-base leading-relaxed whitespace-pre-line" style={{ fontFamily: "'Manrope', sans-serif" }}>
                {s.text}
              </p>
            </section>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
